import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryToner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M12.433 5.915h.287c.318 0 .575.257.575.575V18.16a.46.46 0 0 1-.194.39c-.349.23-1.19.65-2.681.65-1.49 0-2.332-.42-2.681-.65a.46.46 0 0 1-.194-.39V6.49c0-.318.257-.575.575-.575h.287m4.026 0V4.467a.575.575 0 0 0-.575-.575m.575 2.023s-.575.577-2.013.577-2.013-.577-2.013-.577m3.45-2.023V1.386c0-.12-.038-.237-.138-.303C11.539.964 11.155.8 10.42.8s-1.118.164-1.298.283c-.1.066-.14.184-.14.303v2.506m2.876 0s-.575.3-1.438.3-1.438-.3-1.438-.3m0 0a.575.575 0 0 0-.575.575v1.448"
    />
  </svg>
);
export default SvgPrimaryToner;
